import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { OrderService } from 'src/app/services/order/order.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';

@Component({
  selector: 'app-wallet-method',
  templateUrl: './wallet-method.page.html',
  styleUrls: ['./wallet-method.page.scss'],
})
export class WalletMethodPage implements OnInit {
  userID;
  invoiceNo;
  docID;
  fee;

  wallet;

  btnClicked = false;

  constructor(
    private userProfileService: UserProfileService,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((res) => {
      this.userID = res.userID;
      this.invoiceNo = res.invoiceNo;
      this.docID = res.docID;
      this.fee = res.deliveryFee;

      this.userProfileService
        .getUserWallet(this.userID)
        .pipe(take(1))
        .subscribe((data) => {
          this.wallet = data.data();
        });
    });
  }

  pay() {
    this.btnClicked = true;
    const method = 'Wallet';
    this.userProfileService
      .useWallet(this.userID, this.fee)
      .then(() => {
        this.orderService.updateOrder(this.docID, method).then(() => {
          this.btnClicked = false;
          alert('Payment Made');
          this.router.navigate(['/user-orders']);
        });
      })
      .catch((e) => {
        alert('Could not transact wallet');
      });
  }
}
